import { useNavigate, useLocation } from "react-router-dom";
import { FiLogOut, FiMenu } from "react-icons/fi";

export default function Sidebar({ sidebarOpen, setSidebarOpen, handleLogout }) {
  const navigate = useNavigate();
  const location = useLocation();


  const adminSidebarItems = [
    { label: "Dashboard", path: "/dashboard" },
    // { label: "Managers", path: "/dashboard/managers" },
    // { label: "Teachers", path: "/dashboard/teachers" },
    { label: "Students", path: "/dashboard/students" },
    { label: "Batches", path: "/dashboard/batches" },
    { label: "Attendance", path: "/dashboard/attendance" },
    { label: "Courses", path: "/dashboard/courses" },
    { label: "courses JSON", path: "/dashboard/coursesJSON" },
    { label: "Individual JSON", path: "/dashboard/IndividualJSON" },
    { label: "Services JSON", path: "/dashboard/services" },
    { label: "Blogs", path: "/dashboard/blogs" },
    { label: "GstInvoices", path: "/dashboard/GstInvoicesPage" },
    { label: "Contact Messages", path: "/dashboard/ContactMessages" },
    { label: "Demo Requests", path: "/dashboard/demorequests" },
    { label: "Coupons", path: "/dashboard/coupons" },
  ];

  return (
    <div
      className={`${sidebarOpen ? "w-64" : "w-20"
        } bg-black/40 border-r border-white/10 backdrop-blur-xl transition-all duration-300 flex flex-col`}
    >
      {/* Logo */}
      <div className="p-4 flex items-center justify-between">
        <span className="text-xl font-bold text-orange-500">
          {sidebarOpen ? "SkillAura" : "SA"}
        </span>

        <button onClick={() => setSidebarOpen(!sidebarOpen)}>
          <FiMenu />
        </button>
      </div>

      {/* Menu */}
      <div className="flex-1 px-2 space-y-2 overflow-y-scroll">
        {adminSidebarItems.map((item, index) => {
          const isActive = location.pathname === item.path;

          return (
            <div
              key={index}
              onClick={() => navigate(item.path)}
              className={`p-3 rounded-lg cursor-pointer transition-all
                ${isActive
                  ? "bg-orange-500 text-white"
                  : "hover:bg-white/10 text-slate-300"
                }`}
            >
              {sidebarOpen ? item.label : item.label.charAt(0)}
            </div>
          );
        })}
      </div>

      {/* Logout */}
      <div className="p-4 border-t border-white/10">
        <button
          onClick={handleLogout}
          className="w-full p-2 rounded-lg bg-red-500 hover:bg-red-600 text-white"
        >
          {sidebarOpen ? "Logout" : "⎋"}
        </button>
      </div>
    </div>
  );
}